export default "__VITE_ASSET__D7oS7hOt__"